import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import React from 'react';
import { AuthState, GroupIModule, GroupIPermission } from './AppShell/Authentication/AuthorisationModels';
import { SectionTitle } from './Components/Typography/SectionTitle';
import { PermissionControl } from './PermissionControl';
import styles from './PermissionSet.module.scss';

type PermissionSetProps = {
    module: GroupIModule;
    moduleIndex: number;

    onAllowAll(): void;
    onDenyAll(): void;
    onInheritAll(): void;
    permissionChange(moduleIndex: number, permissionIndex: number, state: AuthState, inherited: boolean): void;
};

export class PermissionSet extends React.Component<PermissionSetProps> {
    public isBulkAllowed(): boolean {
        return this.props.module.permissions.every(
            permission => permission.state === AuthState.Allowed && !permission.inherited
        );
    }

    public isBulkDenied(): boolean {
        return this.props.module.permissions.every(
            permission => permission.state === AuthState.Denied && !permission.inherited
        );
    }

    public isBulkInherited() {
        return this.props.module.permissions.every(permission => permission.inherited);
    }

    public render() {
        return (
            <Grid
                key={this.props.module.moduleCode + '-' + this.props.moduleIndex}
                container
                className={styles.gridContainer}
                spacing={0}>
                <Grid item xs={12}>
                    <Grid container direction='column'>
                        <Grid item>
                            <h2 className={styles.heading}>{this.props.module.name}</h2>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={4} md={4} lg={3} xl={3}>
                            <SectionTitle title='FEATURE' />
                        </Grid>
                        <Grid item xs={8} md={8} lg={9}>
                            <SectionTitle title='SET PERMISSION' />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={0}>
                        <Grid item xs={4} md={4} lg={3} xl={3} />
                        <Grid item xs={8} md={8} lg={9}>
                            <div className={styles.bulkPermissionControl}>
                                <FormControlLabel
                                    classes={{ root: styles.allowAll, label: styles.label }}
                                    control={<Radio checked={this.isBulkAllowed()} onChange={this.props.onAllowAll} />}
                                    label='Allow all'
                                />
                                <FormControlLabel
                                    classes={{ root: styles.denyAll, label: styles.label }}
                                    control={<Radio checked={this.isBulkDenied()} onChange={this.props.onDenyAll} />}
                                    label='Deny all'
                                />
                                <FormControlLabel
                                    classes={{ root: styles.inheritAll, label: styles.label }}
                                    control={
                                        <Radio checked={this.isBulkInherited()} onChange={this.props.onInheritAll} />
                                    }
                                    label='Inherit all'
                                />
                            </div>
                        </Grid>
                    </Grid>
                </Grid>

                {this.props.module.permissions.map((permission: GroupIPermission, permissionIndex) => {
                    return (
                        <PermissionControl
                            key={permission.definitionCode + '-' + permissionIndex}
                            onAllowLocal={() => {
                                this.props.permissionChange(
                                    this.props.moduleIndex,
                                    permissionIndex,
                                    AuthState.Allowed,
                                    false
                                );
                            }}
                            onDenyLocal={() => {
                                this.props.permissionChange(
                                    this.props.moduleIndex,
                                    permissionIndex,
                                    AuthState.Denied,
                                    false
                                );
                            }}
                            onInherit={() => {
                                this.props.permissionChange(
                                    this.props.moduleIndex,
                                    permissionIndex,
                                    permission.inherritablePermission
                                        ? permission.inherritablePermission.state
                                        : AuthState.Denied,
                                    true
                                );
                            }}
                            name={permission.name}
                            state={permission.state}
                            inherritablePermission={permission.inherritablePermission}
                            inherited={permission.inherited}
                        />
                    );
                })}
            </Grid>
        );
    }
}
